
<template>
<div id="chat-area">
    <div class="chat-head">
        <v-toolbar card prominent color="#20202d">
            <v-toolbar-title class="subheading">Chat</v-toolbar-title>
        </v-toolbar> 
    </div>
    <div class="chat-body" ref="scroller" v-if="loggedIn">
        <div class="chat-scroll">
          <div v-for="message in messages" v-bind:key="message.id" class="chat-message">
            <span class="m-avatar">{{ message.user.name.charAt(0) }}</span>
            <span class="m-user">{{ message.user.name }}</span>
            <span class="m-message">{{ message.text }}</span>
          </div>
        </div>
    </div>
    <div class="chat-foot" v-if="loggedIn">
      <form @submit.prevent="sendMessage" method="post">
          <input type="text" v-model="newMessage" placeholder="Type your message..." class="message-input" />
          <button id="send-message-button" type="submit">Send</button>
      </form>
    </div>
    <div class="chat-login" v-if="!loggedIn">
        <div class="chat-login-wrapper">
          <h3>Enter a nickname to join the chat</h3>
          <form @submit.prevent="loginToChat" method="post" class="usernameform">
            <input type="text" v-model="chatUsername" placeholder="nickname" class="username-input" />
            <button id="login-button" type="submit">Go</button>
          </form>
        </div>
    </div>
</div>
</template>

<script>
import axios from "axios";
import { StreamChat } from "stream-chat";
export default {
  data() {
    return {
      token: null,
      channel: null,
      members: [],
      client: null,
      messages: [],
      newMessage: "",
      loggedIn: false,
      chatUsername: null,
      scrolled: false,
      username: null,
      chatroom: null
    };
  },
  computed: { 
      storedChatName(){
          return this.$store.getters.chatname;
      }
  },
  mounted() {
  
    if(this.storedChatName !== null){
      this.chatUsername=this.storedChatName;
      //this.loggedIn = true;
      this.loginToChat();
    }

    this.watchScroll();


  },
  methods: {
    async loginToChat(){

      if(this.chatUsername && this.chatUsername.length > 2){

        await this.getToken();
        await this.initializeStream();
        await this.initializeChannel();

      } else {

        alert('Nickname must be longer than 2 characters');

      }

    },
    async getToken() {
      
      axios.defaults.headers.common = {
          'X-Requested-With': 'XMLHttpRequest'
      };

     // console.log(axios.defaults.headers);

      const { data } = await axios.post("/api/generate-token", {
        username: this.chatUsername
      });
      
      this.token = data.token;
      this.username = data.uuid;
      this.chatroom = data.chatroom;
      this.loggedIn = true;

      if(this.storedChatName==null){
          this.$store.commit('updateChatname', this.chatUsername);
      }

    },
    async initializeStream() {
      console.log('init start');

    
      this.client = new StreamChat(process.env.MIX_STREAM_API_KEY, {
        timeout: 9000
      });
      await this.client.setUser(
        { 
          id: this.username, 
          name: this.chatUsername 
        },
        this.token
      );
    },
    async initializeChannel() {

      
      this.channel = this.client.channel("livestream", this.chatroom);
      const { members, messages } = await this.channel.watch();
      this.members = members;
      this.messages = messages;

      this.scrollToBottom()

      // listen for new messages
      this.channel.on("message.new", event => {
        this.messages.push({
          text: event.message.text,
          user: event.message.user
        });

        if(!this.scrolled){
          this.scrollToBottom()
        }
      });
      // listen for when a new member is added to channel
      this.channel.on("member.added", event => {
        this.members.push(event);
      });

    },
    async sendMessage() {
      await this.channel.sendMessage({
        text: this.newMessage
      });
      this.newMessage = "";
    },
    async scrollToBottom(){

        // var element = this.$refs.scroller;
        console.log('scrollToBottom')

        this.$nextTick(() => { 
          this.$refs.scroller.scrollTop = this.$refs.scroller.scrollHeight - this.$refs.scroller.clientHeight;
         })
      // out.scrollTop = out.scrollHeight - out.clientHeight

    },
    async watchScroll(){

      let self = this;

      this.refs.scroller.onscroll = () => {

        var el = this.refs.scroller;

        console.log('scrolling');

        if(el.scrollTop != el.scrollHeight){
            self.scrolled = true;
        }

      }


    }
  }
};
</script>

<style lang="scss" scoped>

#chat-area { 

    width: 100%;
    background: #191823;
    max-width: 100%;
    display: flex;
    flex-wrap: wrap;
    flex: 1;
    flex-direction: column;

    @media screen and (min-width: 768px){
        min-width: 340px;
        max-width: 400px;


    }

    @media screen and (max-width: 767px){
      flex: 1 0 100px;
      max-height: 420px;
    }

  //  height: 100%;
}

// .chat-pane {
//   // max-height: 100%;
//   position: relative;
//   height: 100%;
//   display: flex;
//   max-width: 100%;


//   @media screen and (max-width: 767px){

//     max-height: 100%;
//     height: auto;
//     flex: 1;

//   }

//   * {
   
//      box-sizing: border-box;
//      max-width: 100%;
//    }
// }

.chat-pane-container {

    display: flex;
    //flex-wrap: wrap;
    flex: 1;
    flex-direction: column;
    height: 100%;
    max-height: 100%;

    
}



.chat-head {
  height: 70px;
}

.chat-body {
  flex: 1 0 100px;
  padding: 10px;
  overflow-y: auto;
  overflow-x: hidden;
  max-width: 100%;
}

.chat-foot {
  height: 100px;
  padding: 10px;
  background: #20202d;
  width: 100%;
 // align-self: flex-end;

  .message-input {
    box-sizing: border-box;
    width: 100%;
    border: 1px solid #eee;
    border-radius: 3px;
    padding: 8px 7px;
    margin-bottom: 8px;

    &:focus {
      border-color: #4cc0ad;
      outline-color: #4cc0ad;
    }
  }

  button#send-message-button {
    background-color: #4cc0ad !important;
    border-radius: 3px;
    color: #fff;
    display:block;
    padding: 5px 10px;
    float: right;
  }

  
}



.chat-message {
    padding: .5rem 1rem;
    word-wrap: break-word;

    .m-avatar {
       background: #4cc0ad;
      display: inline-block;
      font-size: 11px;
      padding: 1px 6px;
      border-radius: 13px;
      margin-right: 2px;
      text-transform: uppercase;
    }

    .m-user {
      font-weight: 700;
      color: #5a40b3;
      display: inline-block;
      margin-right: 5px;
    }

    .m-message {

    }
}


.chat-login {

  flex: 1;
  display: flex;
  align-items: center;


  .chat-login-wrapper{
    flex: 1
  }

  h3 {
    text-align: center;
    font-size: 21px;
  }
 
  .usernameform {
      width: 100%;
      display: flex;
      flex-direction: row;
      padding: 20px 40px;

      


       .username-input {
          flex: 1 0 75%;
          box-sizing: border-box;
          border-radius: 3px 0 0 3px;
          background: #555;
          color: #fff;
          padding: 8px 12px;
          margin-bottom: 0;

          &:focus {
            border-color: #4cc0ad;
            outline-color: #4cc0ad;
          }
        }

        button#login-button {
          flex: 1 0 25%;
          background-color: #4cc0ad !important;
          border-radius: 0 3px 3px 0;
          padding: 8px 7px;

          color: #fff;
          display:block;
        }
  }


}
 

</style>